import Http from '../http'

export const index = (page, name) => Http.get(`/sizes?page=${page}${(name) ? '&name=' + name : ''}`, { headers: { Authorization: localStorage.token } })
export const store = (data) => Http.post('/sizes', { data }, { headers: { Authorization: localStorage.token } })
export const update = (id, data) => Http.patch(`/sizes/${id}`, { data }, { headers: { Authorization: localStorage.token } })
export const destroy = (id) => Http.delete(`/sizes/${id}`, { headers: { Authorization: localStorage.token } })
